// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","inner":"Footer_inner__CVEiR","-hidden":"Footer_-hidden__h0VjW"};